module.exports = "<div class=cssNotesModalBody> <form class=q-pad-all-xl name=cssNotesInputForm id=cssNotesInputForm> <div class=wrapper-helper> <p class=q-marg-bottom-md>You are resolving this error. Please write some notes that explain the error that occurred and the actions that were taken to resolve this error.</p> <div class=q-marg-top-md> <textarea class=\"q-input q-stretch resolution-notes required\" data-error-placement-append-closest=.wrapper-helper name=resolutionNotes></textarea> </div> </div> </form> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/cssNotesModalBody.html
// module id = 1357
// module chunks = 1